import { FC } from 'react'
import { Route, Routes } from 'react-router-dom'

import DirectoryDetailPage from '../pages/Directories/Detail'
import ElementDetailPage from '../pages/Elements/Detail'

const ChatRouter: FC = () => {
  return (
    <Routes>
      <Route path="/:id" element={<DirectoryDetailPage />} />
      <Route
        path="/:directoryId/elements/:elementId"
        element={<ElementDetailPage />}
      />
    </Routes>
  )
}

export default ChatRouter
